import React from "react";
import {getFullName} from "./aphLoanHistoryUtility";
import {truncateString} from "../../../../Utilities/commonUtilities";
import {isAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";

interface AphLoanHistoryRowProps {
    aphLoanHistoryItem: Record<string, any>;
}

export const AphLoanHistoryRow = ({
                                      aphLoanHistoryItem
                                  }: AphLoanHistoryRowProps) => {

    return (
        <tr id={aphLoanHistoryItem.aphLoanItemId}>
            <td>
                {aphLoanHistoryItem.aphCatalogItem.title}
            </td>
            <td>
                {getFullName(aphLoanHistoryItem.patron)}
            </td>
            <td>
                {getFullName(aphLoanHistoryItem.student)}
            </td>
            <td>
                {aphLoanHistoryItem.districtName}
            </td>
            <td>
                {aphLoanHistoryItem.organization}
            </td>
            <td>
                {aphLoanHistoryItem.shippingLocation.name}
            </td>
            <td>
                {aphLoanHistoryItem.dateFulfilledFormatted}
            </td>
            <td>
                {aphLoanHistoryItem.aphLoanStatusText}
            </td>
            <td>{
                isAdmin() &&
                truncateString(aphLoanHistoryItem.aphLoanNotes)
            }
            </td>
        </tr>
    );
};